import { render } from "./validateIdCard.vue?vue&type=template&id=6a9dff4e&scoped=true"
import script from "./validateIdCard.vue?vue&type=script&lang=js"
export * from "./validateIdCard.vue?vue&type=script&lang=js"

import "./validateIdCard.vue?vue&type=style&index=0&id=6a9dff4e&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9dff4e"]])

export default __exports__